import { useQuery } from '@pinia/colada';
import { AxiosError } from 'axios';
import { computed } from 'vue';

import buildingService from '../services/building.service';

export const buildingsQueryKey = 'buildings';
export const buildingQueryKey = 'building';

export function getBuildingQueryKey(buildingId: string) {
  return [buildingQueryKey, buildingId];
}

/** Every building of the company: any seat sees them all. Not asked for where the page shows none */
export function useBuildingsQuery(enabled: () => boolean = () => true) {
  const { data, ...rest } = useQuery({
    key: () => [buildingsQueryKey],
    enabled,
    query: () => buildingService.list(),
  });

  const buildings = computed(() => data.value ?? []);

  return { ...rest, data, buildings };
}

/** The stats strip of the building page: its units' last 30 days */
export function useBuildingStatisticsQuery(buildingId: () => string) {
  return useQuery({
    key: () => [...getBuildingQueryKey(buildingId()), 'statistics'],
    enabled: () => Boolean(buildingId()),
    query: () => buildingService.getStatistics(buildingId()),
  });
}

/** The building of the page; `isMissing` says the link points at a building that is gone or was never there */
export function useBuildingQuery(buildingId: () => string) {
  const { error, ...rest } = useQuery({
    key: () => getBuildingQueryKey(buildingId()),
    enabled: () => Boolean(buildingId()),
    query: () => buildingService.getById(buildingId()),
  });

  const isMissing = computed(() => error.value instanceof AxiosError && error.value.response?.status === 404);

  return { ...rest, error, isMissing };
}
